var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00AEEF;}\n\t.st1{fill:none;stroke:#008DC9;stroke-width:9.9643;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{display:none;}\n\t.st4{display:inline;fill:#201600;stroke:#201600;stroke-width:0.1;stroke-linecap:square;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_66_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    className: "st0",
    d: "M75,144.8c38.5,0,69.8-31.2,69.8-69.8c0-38.5-31.2-69.8-69.8-69.8C36.5,5.2,5.2,36.5,5.2,75 C5.2,113.5,36.5,144.8,75,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st1",
    d: "M139.8,75c0,35.8-29,64.8-64.8,64.8s-64.8-29-64.8-64.8s29-64.8,64.8-64.8 S139.8,39.2,139.8,75z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    className: "st2",
    d: "M46.4,52.6c0-8.3,6.7-14.9,14.9-14.9h14.9c8.3,0,14.9,6.7,14.9,14.9v20.7h0 c6,0,10.8,4.9,10.8,10.8v14.1c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2V70.9c-0.8,0.2-1.7,0.4-2.7,0.4c-5.2,0-9.3-4.2-9.3-9.3 c0-3.7,2.1-6.8,5.2-8.4l-5-5c-1.3-1.3-1.3-3.4,0-4.8c1.3-1.3,3.4-1.3,4.8,0l10.6,10.6c2,2,3.2,4.8,3.2,7.7v36.1c0,5-4,9-9,9 c-5,0-9-4-9-9V84.1c0-2.3-1.8-4.1-4.1-4.1h0v17.5c0,8.3-6.7,14.9-14.9,14.9H61.3c-8.3,0-14.9-6.7-14.9-14.9V52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st0",
    d: "M53.8,52.6c0-4.1,3.3-7.5,7.5-7.5h14.9c4.1,0,7.5,3.3,7.5,7.5v11.2c0,4.1-3.3,7.5-7.5,7.5 H61.3c-4.1,0-7.5-3.3-7.5-7.5V52.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_71_",
    className: "st0",
    cx: 103.9,
    cy: 61.9,
    r: 2.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Linear",
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_70_",
    className: "st4",
    x1: 145,
    y1: -1.8,
    x2: 145,
    y2: 166.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_69_",
    className: "st4",
    x1: 155.5,
    y1: 145,
    x2: -13.2,
    y2: 145
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_68_",
    className: "st4",
    x1: 5,
    y1: -12,
    x2: 5,
    y2: 156.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_67_",
    className: "st4",
    x1: 158.3,
    y1: 5,
    x2: -10.4,
    y2: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/43f5c4b2cf2603d8ea811e7cf81b3ee4e3053a8106.svg";
export { ForwardRef as ReactComponent };